// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__32iTB","name":"Header_name__2jra3","birthday":"Header_birthday__1oR9V","skeleton":"Header_skeleton__oLuFr"};